import './StubPage.css';

// TODO - Replace Surf School: the live /about route on the source Framer site has
// no published content yet (it renders an empty shell) - fill in once it exists.
export function AboutPage() {
  return (
    <main className="stub-page">
      <div className="section-inner">
        <h1>About</h1>
        <p>TODO - add About page content once it's published on the source site.</p>
      </div>
    </main>
  );
}
